import { combineReducers } from 'redux';
import storage from 'redux-persist/lib/storage';
import productReducer from './action/product';
import globalReducer from './action/global';
import contactreducer from "./action/contact";
import whychooserReducer from "./action/whyChoose";
import otherTypeReducer from "./action/otherType";
import flowerReducer from "./action/flower";
import groupReducer from "./action/groups";
import flowerPackageReducer from "./action/flower-package";
import imageAlbumReducer from "./action/image-album";
import { image } from '@cloudinary/url-gen/qualifiers/source';






export const rootPersistConfig = {
  key: 'root',
  storage,
  keyPrefix: 'redux-',
  whitelist: [],
};
export type RootState = ReturnType<typeof rootReducer>;

const rootReducer = combineReducers({
  product:productReducer,
  global:globalReducer,
  contact:contactreducer,
  whyChoose:whychooserReducer,
  otherType:otherTypeReducer,
  flower:flowerReducer,
  group:groupReducer,
  flowerPackage:flowerPackageReducer,
  imageAlbum:imageAlbumReducer,

});

export default rootReducer;
